import api from '../api'

export default {

  dashboard: async () => {
    return api.get(`api/reports/dashboard`)
  },

  outstandingBalances: async () => {
    return api.get(`api/reports/outstanding-balances`)
  },

  
}
